module.exports = "/fonts/vendor/@flaticon/flaticon-uicons/css/uicons-thin-straight-JPCGBQEF.woff?b56bfa32f1ed9684b10339451ad07ee7";